import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e2ae83f6")

_pushScopeId("data-v-e2ae83f6")
const _hoisted_1 = {
  playsinline: "",
  autoplay: "",
  muted: "",
  loop: "",
  id: "background-video"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("video", _hoisted_1, [
    _createVNode("source", {
      src: _ctx.src,
      type: "video/mp4"
    }, null, 8, ["src"])
  ]))
})